import {createContext} from 'react'

export const ReferralContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  referrals: [],
  setReferrals: () => {
  },
  referral: {
    id: null,
    person_id: null,
    referral_config_id: null,
    status: "",
    person_name: "",
    person_phone: "",
    title: "",
    type: "",
    value: null,
    referrer_share: null,
    referee_share: null,


  },
  setReferral: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
  roleId: null,
  setRoleId: () => {
  },
})